import { providers } from '../../providers';
import { wavespeed } from '../wavespeed/index';
import type { TersaSpeechModel } from '../types';
import { seedSpeechVoices } from './voices/seed-voices';

// 系数
const COST_FACTOR = 2;

export const bytedanceModels: Record<string, TersaSpeechModel> = {
  'seed-2.0-speech-tts': {
    promptLabel: 'Text',
    lyricsLabel: 'Voice Style',
    chef: providers.bytedance,
    providers: [
      {
        ...providers.bytedance,
        model: wavespeed.speech('seed-2.0-speech-tts'),
        getCost: ({ characters }) => {
          const units = Math.max(1, Math.ceil((characters ?? 0) / 1000));
          return units * 0.03 * COST_FACTOR;
        },
      },
    ],
    voices: ['lyrics', ...seedSpeechVoices],
    voiceLabelPrefix: 'audio.voice.bytedance',
    precheck: ['prompt'],
    supportsInput: ['t2a'],
    priceIndicator: 'lowest',
    price: 'Dynamic',
  },
};